import { render, staticRenderFns } from "./AdminCreateWorkedShift.vue?vue&type=template&id=54b97860&scoped=true"
import script from "./AdminCreateWorkedShift.vue?vue&type=script&lang=js"
export * from "./AdminCreateWorkedShift.vue?vue&type=script&lang=js"
import style0 from "./AdminCreateWorkedShift.vue?vue&type=style&index=0&id=54b97860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b97860",
  null
  
)

export default component.exports